module.exports = __webpack_public_path__ + "static/img/phonelogo.e83db9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phonelogo.png
// module id = Ter3
// module chunks = 56